import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery'


class Webdesign extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();


        $("#webdesign-li").addClass("active");
        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="webdesign">
            <span>
                <h1>Nabídka tvorby www stránek</h1>
                Ricom Zdeněk Richtr nabízí kompletní zpracování vaší prezentace od grafických návrhů, programování on-line aplikací, realizaci složitých projektů až po firemní intranety. Zajišťujeme také editační práce hotových projektů a zprostředkování hostingu. Nabízíme dvojí typ internetové prezentace: <b>statická</b> a <b>dynamická</b>. Během konzultace se zákazníkem navrhneme nejoptimálnější řešení, které povede k vaší spokojenosti a ztvárnění vašich představ.
<br/><br/>
                <h2>Statická prezentace</h2>
                Je nejjednodušší formou prezentace. S úspěchem jí využívají zákazníci, kteří svou nabídku a informace na internetu nepotřebují aktualizovat. Data jsou umístěná "natvrdo" a lze je změnit jen zásahem do programového kódu. S případnou pozdější aktualizací dat vám samozřejmě rádi pomůžeme. Lze také již hotovou prezentaci později přetvořit na dynamickou.
<br/><br/>
                <h2>Varianta MINIMUM</h2>
                Prezentace klasického designu bez grafických prvků, která může využívat rámce. Prezentace obsahuje jen několik stránek bez složitého listování. Neobsahuje žádné aktivní prvky, statistiky.
<br/><br/>
                <h2>Varianta NORMAL</h2>
                Prezentace profesionálního designu využívající fotomontáží a počítačových koláží. Většinou design navrhujeme v Clean stylu, nebo lze využít šablon dostupných na internetu. Ve stránce mohou být použité jednoduché animace, pohyb textu pomocí Javascriptu, formulářové zpracování dat, zasílání dotazů emailem a podobně.
<br/><br/>
                <h2>Dynamická prezentace</h2>
                Náročný zákazník nemůže být spokojen jen s jednoduchou prezentací, která nezobrazí image společnosti. Prezentaci je potřeba neustále ošetřovat, aktualizovat, doplňovat nabídkou nových produktů. Při tvorbě dynamické prezentace je počítáno s měnícími se daty či neustále přibývajícími položkami. Tyto měnící se data se ukládají do databáze, která je centrálně shromažďuje. Jednu informaci tak lze například zobrazovat na více místech najednou. Data lze různě katalogizovat, řadit, lze vytvářet tiskové reporty, lze s nimi provádět i matematické operace.
<br/><br/>
                <h2>Varianta STANDARD</h2>
                Profesionální a originální vzhled prezentace lze dotvářet naším grafikem formou vašich připomínek v průběhu tvorby návrhu. Je použito sladění decentních kombinací barev zajišťujících přehlednost prezentace s maximální optimalizací načítání pro návštěvníky s pomalým připojením.
<br/><br/>
                <h2>Firemní Intranet</h2>
                Vytváříme rozsáhlé intranetové projekty založené na PHP, MySQL, PostgreSQL, Firebird a Apache, zajišťující rychlý přístup k firemním informacím. Intranet může obsahovat správce firemních dokumentů, nástěnky, diskuzní fóra, telefonní seznamy a další komponenty dle přání zákazníka. Lze zapojit i redakční systém, správu klientů a jejich uživatelských práv, moduly downloadu souborů, uživatelské galerie, reklamní systémy se správou kampaní, editace anket, komentářů či vlastní funkce zálohy databází. Cena se vždy stanoví dle rozsáhlosti projektu.
<br/><br/>
                <h2>Další nabídka</h2>
                Vytvoření domény a webhostingu - Nemáte svůj server, na kterém by vaše nová prezentace byla umístěná, nebo si chcete založit novou doménu a nevíte jak? Ochotně vám pomůžeme při vytváření domény druhé i třetí úrovně, převodu domén pod registrátora a zprovoznění webhostingu. Celkově se vlastně nemusíte o nic starat, novou prezentaci vytvoříme optimalizovanou i pro pravidla poskytovatelů webhostingu. Každý poskytovatel má totiž své servery jinak zabezpečené.
<br/><br/>
                Podrobný ceník prací a služeb naleznete <Link to="/sluzby-a-produkty/cenik-praci-a-sluzeb">zde.</Link>

            </span>
        </div>


</div>
    );
  }
}

export default Webdesign;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/Webdesign.js